<template>
<div class="dropdown" ref="dropdownElement">
  <button type="button" :class="buttonCss" data-bs-toggle="dropdown" aria-expanded="false">
    {{label}}
  </button>
  <ul class="dropdown-menu" :aria-label="label">
    <li v-for="index in itemCount">
        <slot :name="`item${index}`" v-bind:item="index">            
        </slot>        
    </li> 
  </ul>
</div>
</template>
<script setup lang="ts">

import { Dropdown } from 'bootstrap';
import { computed, onMounted, ref, watch } from "vue";

const props = defineProps<{
    itemCount: number
    label: string;
    isPrimaryButton: boolean;
}>();

let dropdownElement = ref(null);
let dropdownObject = {} as Dropdown;

const state = ref(false);

onMounted(() => {
    if(dropdownElement?.value != undefined){
        dropdownObject = new Dropdown(dropdownElement.value);        
    }    
});

const buttonCss= computed(()=> {
    let css= "btn border border-secondary dropdown-toggle";
    if(props.isPrimaryButton){
        css = "btn btn-primary dropdown-toggle";
    }

    return css;
})

function _show() {
    state.value = true;
    if(dropdownObject){
        dropdownObject.show();
    }
}

function _hide() {
    state.value = false;

    if(dropdownObject){
        dropdownObject.hide();
    }
}

defineExpose({ show: _show, hide: _hide });
</script>